import React, { useEffect, useState } from 'react'
import { Select } from './style';
import axios from 'axios';

interface PropsType {
  stages: Stage[];
  selectedStage: number;
  onSelectStage: (stageId: number) => void;
}

interface Stage {
  id: number
  name: string
}

const StageSelector =({ selectedStage, onSelectStage }:any) => {
  const [ stages, setStages ] = useState<Stage[]>([])
  
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/stages`)
      .then((response) => {
        if(response.data) setStages(response.data)
      })
      .catch((error) => {
        console.error(error)
      })
  },[])
  
  return (
    <Select 
      id="stage-selector" 
      value={selectedStage}
      onChange={(e:any) => onSelectStage(e.target.value)}
    >
      {stages.map((item, index) => (
        <option key={index} value={item.id}>
          {item.name}
        </option>
      ))}
    </Select>
  );
}

export default StageSelector